var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Pagination from "../../common/components/Pagination";
import { Loading } from 'element-ui';
import { mapGetters, mapActions } from "vuex";
import MemberBalanceManageService from "../../api/MemberBalanceManageService";
import CommonService from "../../api/CommonService";
import GlobalVue from "../../globalVue";
import { EBillType } from "../../enum/EBillType";
import { UrlHelper } from "../../helper/UrlWrapper";
import { EPurSortingStatus } from "../../enum/EStatus";
import AreaShop from "@/components/AreaShop";
import rechargeManageList from '../rechargeManage/List.vue';
import balanceManageDetail from './Detail';
import moment from 'moment';
function getDefaultFormData() {
    return {
        text: "",
        s_time: moment().subtract(30, 'days').format('YYYY-MM-DD'),
        e_time: moment().format('YYYY-MM-DD'),
        shop: null,
    };
}
function tidyDepotList(treeData) {
    treeData.forEach(function (item) {
        if (item.organ_id && !item.depot_id) {
            item.isDisabled = true;
            item.depot_id = "organ_id_" + item.organ_id;
            item.depot_name = item.organ_name;
        }
        if (item.children && item.children.length) {
            tidyDepotList(item.children);
        }
    });
}
var PurSorting = (function (_super) {
    __extends(PurSorting, _super);
    function PurSorting() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = getDefaultFormData();
        _this.statusList = [];
        _this.tableData = [];
        _this.selectedData = [];
        _this.tableHeight = 0;
        _this.total = 0;
        _this.eBillType = EBillType;
        _this.ePurSortingStatus = EPurSortingStatus;
        _this.dialogVisible = false;
        _this.exportType = "1";
        _this.isMoreSearch = false;
        _this.dateTypeList = [{ name: "制单日期", id: "1" }, { name: "到货日期", id: "2" }];
        _this.depotList = [];
        _this.exportDetail = {};
        _this.importTypeList = [
            { id: 1, name: '分拣导出-门店分拣' },
            { id: 2, name: '分拣导出-货品分拣' }
        ];
        _this.importType = 1;
        _this.dialogTableVisible = false;
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = "";
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = "";
        _this.organBusiness = [];
        return _this;
    }
    PurSorting.prototype.created = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.$el && _this.$el.parentElement) {
                _this.tableHeight = _this.$el.parentElement.clientHeight - 120;
            }
        }, 300);
        this.service = MemberBalanceManageService.getInstance();
        this.commonService = CommonService.getInstance();
        console.log(this.Root_PageAuth, "Root_PageAuth");
    };
    PurSorting.prototype.mounted = function () {
        this.getOrganDepot({ type: 3, freeze: 0 });
        this.getList();
    };
    PurSorting.prototype.getOrganDepot = function (params) {
        var _this = this;
        params = params ? params : {
            type: 1
        };
        this.commonService.getShopFilter(params).then(function (res) {
            if (res.data.success) {
                var depot = Array.isArray(res.data.data) ? res.data.data : [];
                _this.organBusiness = depot;
                console.log(_this.organBusiness);
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    PurSorting.prototype.getList = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        if (this.isMoreSearch) {
            this.isMoreSearch = false;
        }
        ;
        var params = {
            keyword: this.formData.text,
            s_time: this.formData.s_time,
            e_time: this.formData.e_time,
            shop_ids: (this.formData.shop || []).join(','),
        };
        Object.assign(params, pager);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getList(params).then(function (res) {
            var data = res.data.data;
            _this.tableData = data;
            _this.total = res.data.total;
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    PurSorting.prototype.pageChange = function () {
        this.getList();
    };
    PurSorting.prototype.sortChange = function (_a) {
        var column = _a.column, prop = _a.prop, order = _a.order;
        if (!prop) {
            this.order = null;
        }
        else {
            this.order = [prop, order === 'ascending' ? 'asc' : 'desc'];
        }
        this.getList();
    };
    PurSorting.prototype.selectionChange = function (val) {
        this.selectedData = val;
    };
    PurSorting.prototype.searchClick = function () {
        this.$refs.pagination.clear();
        this.getList();
    };
    PurSorting.prototype.reset = function () {
        this.formData = getDefaultFormData();
    };
    PurSorting.prototype.getSelectIds = function () {
        var orderIds = this.selectedData.map(function (item) { return item.order_id; });
        return orderIds;
    };
    PurSorting.prototype.normalizer = function (node) {
        return {
            id: node.id,
            label: node.name,
            children: node.children,
        };
    };
    PurSorting.prototype.shopSelect = function (node) {
        this.formData.shop = node.shop_contact;
    };
    PurSorting.prototype.addTab = function (options) {
        options.opener = this;
        GlobalVue.$emit('addTab', options);
    };
    PurSorting.prototype.closeTab = function () {
        var closeBtnArr = $(".navTabsCloseBtn").prev();
        for (var i = 0; i < closeBtnArr.length; i++) {
            var titleList = ['客户余额流水明细', '充值管理'];
            if (titleList.includes($(closeBtnArr[i])[0].innerText)) {
                console.log($(closeBtnArr[i]).next());
                $(closeBtnArr[i]).next().click();
            }
        }
    };
    PurSorting.prototype.lookDetail = function (row) {
        this.closeTab();
        this.getAuth("12009").then(function (pageAuth) {
            GlobalVue.$emit('addTab', {
                component: rechargeManageList,
                title: "充值管理",
                showExist: true,
                name: "recharge_list",
                cprops: {
                    shopCode: row.shop_id,
                    Root_PageAuth: pageAuth && pageAuth.Auth,
                    root_PageAuth$$: pageAuth && pageAuth.Auth
                }
            });
        });
    };
    PurSorting.prototype.lookBalanceDetail = function (row) {
        this.closeTab();
        this.getAuth("12009").then(function (pageAuth) {
            GlobalVue.$emit('addTab', {
                component: balanceManageDetail,
                title: "客户余额流水明细",
                showExist: true,
                name: "recharge_detail",
                cprops: {
                    shopId: row.shop_id,
                    Root_PageAuth: pageAuth && pageAuth.Auth,
                    root_PageAuth$$: pageAuth && pageAuth.Auth
                }
            });
        });
    };
    PurSorting.prototype.exportData = function () {
        var pager = this.$refs.pagination.getPage();
        if (this.isMoreSearch) {
            this.isMoreSearch = false;
        }
        ;
        var params = {
            keyword: this.formData.text,
            s_time: this.formData.s_time,
            e_time: this.formData.e_time,
            shop_ids: (this.formData.shop || []).join(','),
        };
        Object.assign(params, pager);
        var listShopIds = this.selectedData.map(function (item) { return item.shop_id; });
        var url = "supplierclientapi/shop_finance/export_summary?list_shop_ids=" + listShopIds.join(",");
        for (var key in params) {
            params[key] = (params[key] === undefined || params[key] === null) ? '' : params[key];
            url = UrlHelper.addParam(url, key, params[key]);
        }
        url = UrlHelper.addParam(url, "token", this.user.token);
        location.href = url;
    };
    PurSorting = __decorate([
        Component({
            methods: __assign({}, mapActions(["getAuth"])),
            components: {
                'pagination': Pagination,
                "areaShop": AreaShop
            },
            computed: __assign({}, mapGetters({
                "user": "user",
                "serviceData": 'serviceData',
                "serviceDataList": 'serviceDataList'
            }))
        })
    ], PurSorting);
    return PurSorting;
}(Vue));
export default PurSorting;
